import { createRegistry, type GameRegistry } from '@campfire/engine';
import { cheat } from '@campfire/game-cheat';
import { goFish } from '@campfire/game-go-fish';
import { oldMaid } from '@campfire/game-old-maid';
import { cardTable } from '@campfire/game-table';
import { holdem } from '@campfire/game-holdem';
import { uno } from '@campfire/game-uno';
import { chutes } from '@campfire/game-chutes';
import { sorry } from '@campfire/game-sorry';
import { parcheesi } from '@campfire/game-parcheesi';
import { candyland } from '@campfire/game-candyland';
import { yahtzee } from '@campfire/game-yahtzee';
import { mastermind } from '@campfire/game-mastermind';
import { battleship } from '@campfire/game-battleship';
import { checkers } from '@campfire/game-checkers';
import { chess } from '@campfire/game-chess';
import { farkle } from '@campfire/game-farkle';
import { liarsDice } from '@campfire/game-liars-dice';
import { hearts } from '@campfire/game-hearts';
import { spades } from '@campfire/game-spades';
import { euchre } from '@campfire/game-euchre';
import { crazyEights } from '@campfire/game-crazy-eights';
import { gin } from '@campfire/game-gin';
import { rummy500 } from '@campfire/game-rummy500';
import { war } from '@campfire/game-war';

/** All installed games. Hosts (Node, browser hot-seat, native) share this list. */
export function createDefaultRegistry(): GameRegistry {
  const r = createRegistry();
  r.register(cardTable);
  r.register(war);
  r.register(goFish);
  r.register(oldMaid);
  r.register(cheat);
  r.register(uno);
  r.register(holdem);
  r.register(chutes);
  r.register(sorry);
  r.register(parcheesi);
  r.register(candyland);
  r.register(yahtzee);
  r.register(mastermind);
  r.register(checkers);
  r.register(chess);
  r.register(battleship);
  r.register(farkle);
  r.register(liarsDice);
  r.register(hearts);
  r.register(spades);
  r.register(euchre);
  r.register(crazyEights);
  r.register(gin);
  r.register(rummy500);
  return r;
}
